import * as React from "react"
import cx from "classnames"
import parse from "html-react-parser"

import styles from "./wysiwyg.module.scss"

const Wysiwyg = ({ className, contentHtml = "" }) => {
  if (!contentHtml) {
    return null
  }

  return (
    <div className={cx(styles.wysiwyg, className)}>{parse(contentHtml)}</div>
  )
}

export default Wysiwyg
